var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-card',{staticClass:"report_card",staticStyle:{"text-align":"center"}},[(_vm.have_data)?_c('span',{staticClass:"content"},[_vm._v(_vm._s(_vm._f("delim")(_vm.data)))]):_vm._e(),_c('br'),_vm._v("\n  Ledgers closed\n")])}
var staticRenderFns = []

export { render, staticRenderFns }